  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-card style="margin:auto;" width="1200" >
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading  "></v-progress-linear>

    <v-data-table    :headers="headers"  :items="cursos" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

        <v-btn @click="openDialog()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Registrar Curso </v-btn >

          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Consultar Cursos( Nível ) registrados</v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          <!--  search  -->
          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa"
            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab dark small
              color="#006699"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
              <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small  >edit</v-icon>Editar</v-list-item>
              <v-list-item @click="setEliminar(item)"><v-icon color="red" small  >delete</v-icon>Eliminar</v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>
    </v-card>
 


    <!-- ============================== DIALOGO Para salvar uma turma ====================== -->


      <template>
  <v-row justify="center">
<v-form
  ref="form"
  v-model="valid"
  lazy-validation
>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-title style="background-color:#006699;color:white;">
          <span class="text-h5">Registrar Novo curso</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              > <v-text-field
                 :disabled="true"
                 v-model="curso_obj.nivel"
                  label="Nível "
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
               <v-text-field
                  v-model="curso_obj.curso"
                  :rules="ruleRequired"
                  label="Nome do curso"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*Preencha correctamente os campos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="closeDialog()"
          >
            fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="!valid"
            @click="Guardar()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-form>
  </v-row>
  </template>
    <!-- ===================================================================================== -->
  </div>
</div>
</div>
</template>
 <script>
import Swal from 'sweetalert2'
 import axios from '../../plugins/axios'
 import utilitarios from '../../plugins/utilitarios'
 const ls = require('local-storage')
 export default {

    data: () => ({
      valid:true,
       
      headers: [
      {
        text: 'Descrição',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Nível', value: 'nivel' },
      { text: 'Data criação', value: 'data_' },
      { text: 'Autor', value: 'autor' }
      ],
      turmas: [],
      classes:[],
      classesFiltered: [],
      searchInDb: '',
      cursos:[],
      periodos:[
        {id:"M",descricao:'Manhã'},
        {id:'T',descricao:'Tarde'},
        {id:'N', descricao:'Noite'}
      ],
      dialog: false,
      overlay: false,
      curso_obj:{
        curso:'',
        nivel:'IIº Ciclo do Ensino Segundário - Médio',
      },
      curso_objDefault:{
        curso:'',
        nivel:'IIº Ciclo do Ensino Segundário - Médio',
      },
      ruleRequired: [value => !!value || 'campo obrigatorio'],
    }),

    computed: {

      Integrado () {
        return ls.get('integrado') === '1'
      },
    },

    created(){
      this.initializeCursos()
    },

    methods: {

       closeDialog (){
        this.dialog = false
        this.curso_obj = this.curso_objDefault
        this.$refs.form.resetValidation()
      },

      openDialog (){
         if(this.Integrado){
          Swal.fire('Integração','<p>Para os sistemas integrados, os cursos são registrados no módulo de pedagogia.</p>','warning')
        }else{
            this.dialog = true
        }
      },
      loadclasse () {
       this.classesFiltered = this.classes.filter(c=>c.nivel === this.turma_obj.curso.nivel_ensino)
      },
      async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

   
    async Guardar () {
     
          let existe =  this.cursos.filter( c => c.descricao.toLowerCase() === this.curso_obj.curso.toLowerCase()) 
          if(existe.length){
            utilitarios.showAlertMessage('warning','Este curso já foi registrado.')
          }else{

            try {
              this.overlay = true
              let params = {
                curso: utilitarios.capitalize(this.curso_obj.curso),
                nivel: 'M',
                autor: ls.get('nomeUsuario')
              }
              let result = await axios.post('cursoInsertOrpdate',params)
              if(result.data.affectedRows >= 1){
                utilitarios.showAlertMessage('success','Curso registrado com sucesso.')
                this.dialog = false
                this.curso_obj = this.curso_obj
                this.initializeCursos()
              }else{
                utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
                }
              } catch (error) {
                this.overlay = false
                utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
              }finally{this.overlay = false}

      }
    }
  }
  
 }
 </script>
 
<style scoped>
.bg {
 color:green;
 background: red
}

</style>
